import { render } from "./JournalCategoryArchive.vue?vue&type=template&id=b9b2d95c"
import script from "./JournalCategoryArchive.vue?vue&type=script&lang=js"
export * from "./JournalCategoryArchive.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rebecca/Workspace/repositories/mercator/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__